import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const journalApi = generateNomenApi<{ title: string }>(`/journals`); // TODO SEPARATE journal from nomen

export const journalOptions = generateNomenOptions('journal', journalApi);
